module.exports = __webpack_public_path__ + "img/IOS-icon.d93a86da.png";